import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20flowing%20warm%20golden%20and%20amber%20waves%20of%20light%2C%20dark%20rich%20background%20with%20soft%20glowing%20particles%2C%20luxurious%20theater%20atmosphere%2C%20elegant%20gradient%20textures%2C%20professional%20cinematic%20style%2C%20dramatic%20lighting&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="精品视频平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
          精选每一帧，<span className="text-primary-400">遇见好内容</span>
        </h1>
        <p className="text-background-200 text-sm md:text-base lg:text-lg max-w-2xl mb-8 md:mb-10 leading-relaxed">
          精品视频汇聚海量高质量视频内容，涵盖教育、娱乐、生活、职场等多元领域。
          无论您寻找学习教程还是精彩影视，精品视频平台为您精选每一帧优质内容，随时随地畅享极致视听体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/jiaoyu"
            className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-lg border border-background-300/60 text-background-50 text-sm md:text-base font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-8 md:gap-12 mt-10 md:mt-14">
          {[
            { label: '精品视频', value: '50,000+' },
            { label: '优质创作者', value: '3,200+' },
            { label: '日均访客', value: '120万+' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}